export default {
      id: "icon-refund-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-refund",
      toString: function () {
        return this.url;
      }
    }